<template>
  <div class="about-wrap">
    <navigationBar :contentText="navTitle"></navigationBar>
    <!-- <h1 class="rich_media_title">关于我们</h1> -->
    <div v-html="content"></div>
  </div>
</template>

<script>
  import { get_dict_value_list } from "@/api/common";
  export default {
    data () {
      return {
        content: '',
        navTitle: '', // 无type参数默认标题
        resDictId: 14 // 无type参数默认id
      }
    },
    mounted() {
    this.handleRouteChange();
  },
    watch: {
      // 监听路由对象，query发生变化触发
      $route: {
        handler() {
          this.handleRouteChange();
        },
        immediate: false
      },
    },
    methods: {
      // 抽离公共处理函数：解析type、设置标题、设置id、请求接口
      handleRouteChange() {
        const type = this.$route.query.type;
        if (type === "1") {
          this.navTitle = "隐私协议";
          this.resDictId = 19;
          document.title = "隐私协议"; // 直接设置
        } else {
          this.navTitle = "购物须知";
          this.resDictId = 14;
          document.title = "购物须知"; // 直接设置
        }
        this.getContent();
      },
      getContent () {
        get_dict_value_list({ resDictId: this.resDictId, sort: 'id+desc' })
          .then(res => {
            // console.log(res)
            this.content = res[0].value || '';
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .about-wrap {
    background-color: #fff;
    min-height: 100vh;
    padding: 0.2rem;
  }
  // .rich_media_title {
  //   font-weight: normal;
  //   font-size: .4rem;
  //   line-height: 1.4;
  //   margin-bottom: .3rem;
  //   text-align: center;
  // }
</style>
